<template>
  <div>
    <table v-if="list.deviceStatusList[1]&&list.deviceIsconnected==3">
      <tr>
        <th>{{$t('lang.particulars.wan3g1IP')}}</th>
        <td v-if="list.deviceStatusList[1].dsIp">{{list.deviceStatusList[1].dsIp}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.wan3g1gateway')}}</th>
        <td v-if="list.deviceStatusList[1].dsGateway">{{list.deviceStatusList[1].dsGateway}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.wan3g1NonContiguousSubnetMask')}}</th>
        <td v-if="list.deviceStatusList[1].dsNetmask">{{list.deviceStatusList[1].dsNetmask}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.wan3g1NETWORK')}}</th>
        <td v-if="list.deviceStatusList[1].dsProto==0">PPP</td>
        <td v-else-if="list.deviceStatusList[1].dsProto==1">DHCP</td>
        <td
          v-else-if="list.deviceStatusList[1].dsProto==2"
        >{{$t('lang.particulars.addressStrings')}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.wan3g1DNS1')}}</th>
        <td
          v-if="list.deviceStatusList[1].dsDns"
        >{{list.deviceStatusList[1].dsDns.split(',')[0]}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.wan3g1DNS2')}}</th>
        <td
          v-if="list.deviceStatusList[1].dsDns"
        >{{list.deviceStatusList[1].dsDns.split(',')[1]}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.MODULE_FILE_SUFFIX')}}</th>
        <td
          v-if="model"
        >{{model}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.Operator')}}</th>
        <td
          v-if="Operator"
        >{{Operator}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.supported')}}</th>
        <td
          v-if="supported"
        >{{supported}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.IMSI')}}</th>
        <td v-if="IMSI">{{IMSI}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.IMEI')}}</th>
        <td v-if="IMEI">{{IMEI}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.ICCID')}}</th>
        <td v-if="ICCID">{{ICCID}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr v-if="list.deviceNetStatusList">
        <th v-if="list.deviceNetStatusList[2]">{{$t('lang.particulars.current')}}</th>
        <td v-if="list.deviceNetStatusList[2]&&list.deviceNetStatusList[2].tfNettype!=''">
          <span v-if="list.deviceNetStatusList[2].tfNettype!=''">
            {{list.deviceNetStatusList[2].tfNettype}}
          </span>
          </td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.SignalStrengths')}}</th>
        <td v-if="list.deviceNetStatusList[2]">{{list.deviceNetStatusList[2].tfRssi}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr v-if="list.deviceNetStatusList">
        <th v-if="list.deviceNetStatusList[2]">{{$t('lang.particulars.SIM')}}</th>
        <td
          v-if="list.deviceNetStatusList[2].tfUsim==0"
        >{{$t('lang.particulars.refreshHaves')}}</td>
        <td
          v-else-if="list.deviceNetStatusList[2].tfUsim==1"
        >{{$t('lang.particulars.info_normal_color')}}</td>
        <td
          v-else-if="list.deviceNetStatusList[2].tfUsim==2"
        >{{$t('lang.particulars.package_pin')}}</td>
        <td
          v-else-if="list.deviceNetStatusList[2].tfUsim==3"
        >{{$t('lang.particulars.IMEI_CODE_LEN')}}</td>
        <td
          v-else-if="list.deviceNetStatusList[2].tfUsim==4"
        >{{$t('lang.particulars.aac_card_type')}}</td>
        <td
          v-else-if="list.deviceNetStatusList[2].tfUsim==5"
        >{{$t('lang.particulars.unknown')}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.wan3g1NETWORK_FAUX_QUEUE')}}</th>
        <td
          v-if="list.deviceNetStatusList[2]"
        >{{computeDate(list.deviceNetStatusList[2].tfDuration)}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.wan3g1Connection')}}</th>
        <td v-if="list.deviceStatusList[1].dsIp">{{$t('lang.particulars.connected')}}</td>
        <td v-else>{{$t('lang.particulars.disOpened')}}</td>
        <th>{{$t('lang.particulars.wan3g1UpdateTime')}}</th>
        <td>{{list.deviceStatusList[1].dsUpdate}}</td>
      </tr>
    </table>
    <!-- <p v-else-if="SsPsShow" class="Not-Features">{{$t('lang.particulars.NotSupport')}}</p> -->
    <table v-else>
      <tr>
        <th>{{$t('lang.particulars.wan3g1IP')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
        <th>{{$t('lang.particulars.wan3g1gateway')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.wan3g1NonContiguousSubnetMask')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
        <th>{{$t('lang.particulars.wan3g1NETWORK')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.wan3g1DNS1')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
        <th>{{$t('lang.particulars.wan3g1DNS2')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.MODULE_FILE_SUFFIX')}}</th>
        <td
          v-if="model"
        >{{model}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.Operator')}}</th>
        <td
          v-if="Operator"
        >{{Operator}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.supported')}}</th>
        <td
          v-if="supported"
        >{{supported}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.IMSI')}}</th>
        <td v-if="IMSI">{{IMSI}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.IMEI')}}</th>
        <td v-if="IMEI">{{IMEI}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.ICCID')}}</th>
        <td v-if="ICCID">{{ICCID}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.current')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
        <th>{{$t('lang.particulars.SignalStrengths')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.SIM')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
        <th>{{$t('lang.particulars.wan3g1NETWORK_FAUX_QUEUE')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.wan3g1Connection')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
        <th>{{$t('lang.particulars.wan3g1UpdateTime')}}</th>
        <td>{{$t('lang.particulars.unknown')}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { SecondToDate } from '@/utils/Date.js'
export default {
  props: ['list', 'SsPsShow'],
  data() {
    return {
      IMEI: '',
      IMSI: '',
      ICCID: '',
      // 模块型号，支持制式，运营商
      model: '',
      supported: '',
      Operator: ''
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        // 以|符号来分割是3gwan1还是3gwan2
        let wan2 = this.list.deviceInfo3g4g.split('|')[1]
        let wan2Arr = wan2.split('#')
        this.IMEI = wan2Arr[0]
        this.IMSI = wan2Arr[1]
        this.ICCID = wan2Arr[2]
        let wan2Other = this.list.deviceInfo3g4gOther.split('|')[0]
        let wan2OtherArr = wan2Other.split('#')
        this.model = wan2OtherArr[0]
        this.Operator = wan2OtherArr[1]
        this.supported = wan2OtherArr[2]
      }
    }
  },
  methods: {
    //计算秒数
    computeDate(msd) {
      return SecondToDate(msd)
    },
  }
}
</script>
<style scoped src='./particulars.css'></style>